import { render } from "./MessageModal.vue?vue&type=template&id=2b50fa27"
import script from "./MessageModal.vue?vue&type=script&lang=js"
export * from "./MessageModal.vue?vue&type=script&lang=js"

import "./MessageModal.vue?vue&type=style&index=0&id=2b50fa27&lang=css"

import exportComponent from "/home/cpaps/sistema-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__